import { useState, useEffect } from 'react';
import API_CIFRA from '../config/Variables_apis';

// Centro de mapa de resguardo mientras carga la configuración real (o si el
// fetch falla) — nunca debe dejar el mapa sin centro. Se reemplaza en cuanto
// la instancia tenga su propio centro configurado.
const CONFIGURACION_DEFECTO = {
  nombre_entidad: 'Cifra Negra',
  logo: null,
  banner: null,
  slogan: '',
  mapa_lat: -12.117939985496957,
  mapa_lng: -77.02892645376073,
  marca_agua_incluye_fecha_hora: true,
  marca_agua_incluye_direccion: true,
  marca_agua_incluye_clima: true,
  marca_agua_incluye_logo: true,
};

/**
 * Configuración pública de esta instancia (HU-005) — nombre de la entidad,
 * logo, centro del mapa, y qué campos incluye la marca de agua. Pública,
 * sin token (`API_CIFRA.configuracion.publica`, allowlist del middleware).
 * Mientras carga (o si el fetch falla) devuelve `CONFIGURACION_DEFECTO`, que
 * es exactamente el valor que antes estaba fijo en código — así ninguna
 * pantalla que use este hook queda sin centro de mapa o sin nombre.
 */
const useConfiguracion = () => {
  const [configuracion, setConfiguracion] = useState(CONFIGURACION_DEFECTO);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelado = false;

    fetch(API_CIFRA.configuracion.publica)
      .then((response) => (response.ok ? response.json() : Promise.reject()))
      .then((data) => {
        if (!cancelado) setConfiguracion(data);
      })
      .catch(() => {
        // Se queda con CONFIGURACION_DEFECTO — un fallo acá nunca debe
        // impedir que el mapa ciudadano cargue.
      })
      .finally(() => {
        if (!cancelado) setLoading(false);
      });

    return () => { cancelado = true; };
  }, []);

  return { configuracion, loading };
};

export default useConfiguracion;
